/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Unsubscribe_ResubscribingInputs */

const en_newsletter_unsubscribe_resubscribing = /** @type {(inputs: Newsletter_Unsubscribe_ResubscribingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resubscribing...`)
};

/**
* | output |
* | --- |
* | "Resubscribing..." |
*
* @param {Newsletter_Unsubscribe_ResubscribingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_unsubscribe_resubscribing = /** @type {((inputs?: Newsletter_Unsubscribe_ResubscribingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Unsubscribe_ResubscribingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_unsubscribe_resubscribing(inputs)
});